import { Dispatch, SetStateAction } from 'react';
import styles from './tabs.module.less';

interface TabItem {
  /** 标题 */
  label: string;
  /** key */
  key: number;
  /** 子内容 */
  children: React.ReactNode;
  /** 埋点事件 */
  trackerEvent: () => void;
}

interface TabComponentProps {
  /** 默认选中的tab */
  activeKey: number;
  setActiveKey: Dispatch<SetStateAction<number>>;
  /** tab项列表 */
  items: TabItem[];
}

const TabComponent: React.FC<TabComponentProps> = ({ activeKey, setActiveKey, items }) => {
  // const [activeKey, setActiveKey] = useState<number>(defaultActiveKey);

  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabHeader}>
        {items.map((item) => (
          <div
            key={item.key}
            data-key={item.key}
            data-show={items.length > 1}
            className={`${styles.tabItem} ${activeKey === item.key ? styles.active : ''}`}
            onClick={() => {
              setActiveKey(item.key);
              if (item.key === 2) {
                item.trackerEvent();
              }
            }}
          >
            {item.label}
          </div>
        ))}
      </div>
      <div className={styles.tabContent}>
        {items.map((item) =>
          item.key === activeKey ? (
            <div key={item.key} data-key={item.key}>
              {item.children}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default TabComponent;
